import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserRoleService } from '../../../services/user-role.service';
import { UserSummary } from '../../../models/user.model';
import { Role } from '../../../models/access.model';

@Component({
  selector: 'app-home-page',
  standalone: false,
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.css']
})
export class HomePageComponent {
  users: UserSummary[] = [];
  allRoles: Role[] = [];

  constructor(private router: Router, private userRoleService: UserRoleService) {}

  ngOnInit() {
    this.loadData();
  }

  private loadData() {
    this.userRoleService.getUsers().subscribe(users => {
      this.users = users ?? [];
    }).add(() => {
      this.userRoleService.getRoles().subscribe(roles => {
        this.allRoles = roles ?? [];
      });
    });
  }

  userNeedsAttention(user: UserSummary): boolean {
    const roles = user.roles || [];
    const missingName = !((user.firstName && user.firstName.trim()) && (user.lastName && user.lastName.trim()));
    if (missingName) return true;
    if (roles.length === 0) return true;
    return roles.every(r => !r.isSystemLevel);
  }

  get attentionUsers(): UserSummary[] {
    const list = (this.users || []).filter(u => this.userNeedsAttention(u));
    // Sort: users WITH first+last name at the top, then those missing names
    return list.sort((a, b) => {
      const aHasName = !!(a.firstName && a.firstName.trim()) && !!(a.lastName && a.lastName.trim());
      const bHasName = !!(b.firstName && b.firstName.trim()) && !!(b.lastName && b.lastName.trim());
      if (aHasName === bHasName) return 0;
      return aHasName ? -1 : 1;
    });
  }

  goTo(path: string) {
    this.router.navigate([path]);
  }
}
